import React from 'react';
import { DESIGN_TOKENS } from '../../constants/designTokens';

const brand = DESIGN_TOKENS.brand;

const VARIANT_CLASS = {
    primary: `${brand.primaryBgClass} text-white ${brand.primaryDarkHoverBgClass} shadow-lg ${brand.primaryShadowSoftClass}`,
    ghost: `text-gray-500 bg-gray-100 hover:bg-gray-200`,
    icon: `text-gray-400 ${brand.primaryHoverTextClass} ${brand.primaryLightHoverBgClass}`,
    dangerIcon: 'text-gray-400 hover:text-red-500 hover:bg-red-50',
    unstyled: '',
};

const SIZE_CLASS = {
    md: 'py-3 rounded-xl text-sm font-bold',
    icon: 'p-2 rounded-xl',
};

const AppButton = React.forwardRef(function AppButton({
    type = 'button',
    variant = 'primary',
    size = 'md',
    className = '',
    children,
    ...rest
}, ref) {
    const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
    const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

    return (
        <button
            ref={ref}
            type={type}
            className={`${sizeClass} transition ${variantClass} ${className}`.trim()}
            {...rest}
        >
            {children}
        </button>
    );
});

export default AppButton;
